import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
interface Props {
  onBack: () => void;
}
export function DatenschutzPage({
  onBack
}: Props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="min-h-screen bg-[#020611] pt-32 pb-24" data-id="element-114">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-115">
        <motion.button onClick={onBack} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} className="inline-flex items-center gap-2 text-muted hover:text-accent transition-colors mb-12 group" data-id="element-116">
          <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" data-id="element-117" />
          Zurück zur Startseite
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h1 className="text-3xl md:text-5xl font-heading font-bold leading-tight mb-6" data-id="element-119">
            Datenschutzerklärung
          </h1>
          <p className="text-muted mb-12" data-id="element-120">gem. EU-DSGVO</p>

          <div className="space-y-10 text-foreground/90 leading-relaxed" data-id="element-121">
            <div data-id="element-122">
              <p data-id="element-123">
                Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und
                anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie
                sonstiger datenschutzrechtlicher Bestimmungen ist die:
              </p>
              <p className="mt-4" data-id="element-124">
                PEZULA Projects & Experts GmbH
                <br data-id="element-125" />
                Innungsstr. 5<br data-id="element-126" />
                21244 Buchholz i.d.N.
                <br data-id="element-127" />
                Deutschland
              </p>
              <p className="mt-4" data-id="element-128">
                E-Mail:{' '}
                <a href="mailto:kontakt@pezula.de" className="text-accent hover:text-accent-hover transition-colors" data-id="element-129">
                  kontakt@pezula.de
                </a>
              </p>
            </div>

            <div data-id="element-130">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-131">
                1. Allgemeines zur Datenverarbeitung
              </h2>
              <p data-id="element-132">
                Wir erheben und verwenden personenbezogene Daten unserer Nutzer
                grundsätzlich nur, soweit dies zur Bereitstellung einer
                funktionsfähigen Website sowie unserer Inhalte und Leistungen
                erforderlich ist. Die Erhebung und Verwendung personenbezogener
                Daten unserer Nutzer erfolgt regelmäßig nur nach Einwilligung
                des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine
                vorherige Einholung einer Einwilligung aus tatsächlichen Gründen
                nicht möglich ist und die Verarbeitung der Daten durch
                gesetzliche Vorschriften gestattet ist.
              </p>
            </div>

            <div data-id="element-133">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-134">
                2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten
              </h2>
              <p data-id="element-135">
                Soweit wir für Verarbeitungsvorgänge personenbezogener Daten
                eine Einwilligung der betroffenen Person einholen, dient Art. 6
                Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als
                Rechtsgrundlage. Bei der Verarbeitung von personenbezogenen
                Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei
                die betroffene Person ist, erforderlich ist, dient Art. 6 Abs. 1
                lit. b DSGVO als Rechtsgrundlage. Soweit eine Verarbeitung
                personenbezogener Daten zur Erfüllung einer rechtlichen
                Verpflichtung erforderlich ist, der unser Unternehmen
                unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als
                Rechtsgrundlage. Ist die Verarbeitung zur Wahrung eines
                berechtigten Interesses unseres Unternehmens oder eines Dritten
                erforderlich und überwiegen die Interessen, Grundrechte und
                Grundfreiheiten des Betroffenen das erstgenannte Interesse
                nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage
                für die Verarbeitung.
              </p>
            </div>

            <div data-id="element-136">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-137">
                3. Datenlöschung und Speicherdauer
              </h2>
              <p data-id="element-138">
                Die personenbezogenen Daten der betroffenen Person werden
                gelöscht oder gesperrt, sobald der Zweck der Speicherung
                entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn
                dies durch den europäischen oder nationalen Gesetzgeber in
                unionsrechtlichen Verordnungen, Gesetzen oder sonstigen
                Vorschriften, denen der Verantwortliche unterliegt, vorgesehen
                wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann,
                wenn eine durch die genannten Normen vorgeschriebene
                Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit
                zur weiteren Speicherung der Daten für einen Vertragsabschluss
                oder eine Vertragserfüllung besteht.
              </p>
            </div>

            <div data-id="element-139">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-140">
                4. Bereitstellung der Website und Erstellung von Logfiles
              </h2>
              <p data-id="element-141">
                Bei jedem Aufruf unserer Internetseite erfasst unser System
                automatisiert Daten und Informationen vom Computersystem des
                aufrufenden Rechners. Folgende Daten werden hierbei erhoben:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-1 text-muted" data-id="element-142">
                <li data-id="element-143">
                  Informationen über den Browsertyp und die verwendete Version
                </li>
                <li data-id="element-144">Das Betriebssystem des Nutzers</li>
                <li data-id="element-145">Den Internet-Service-Provider des Nutzers</li>
                <li data-id="element-146">Die IP-Adresse des Nutzers</li>
                <li data-id="element-147">Datum und Uhrzeit des Zugriffs</li>
                <li data-id="element-148">
                  Websites, von denen das System des Nutzers auf unsere
                  Internetseite gelangt
                </li>
              </ul>
              <p className="mt-3" data-id="element-149">
                Die vorübergehende Speicherung der IP-Adresse durch das System
                ist notwendig, um eine Auslieferung der Website an den Rechner
                des Nutzers zu ermöglichen. Hierfür muss die IP-Adresse des
                Nutzers für die Dauer der Sitzung gespeichert bleiben. Die
                Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der
                Website sicherzustellen. Zudem dienen uns die Daten zur
                Optimierung der Website und zur Sicherstellung der Sicherheit
                unserer informationstechnischen Systeme. Rechtsgrundlage für die
                vorübergehende Speicherung der Daten ist Art. 6 Abs. 1 lit. f
                DSGVO.
              </p>
            </div>

            <div data-id="element-150">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-151">
                5. Kontaktformular und E-Mail-Kontakt
              </h2>
              <p data-id="element-152">
                Auf unserer Internetseite ist ein Kontaktformular vorhanden,
                welches für die elektronische Kontaktaufnahme genutzt werden
                kann. Nimmt ein Nutzer diese Möglichkeit wahr, so werden die in
                der Eingabemaske eingegeben Daten an uns übermittelt und
                gespeichert. Alternativ ist eine Kontaktaufnahme über die
                bereitgestellte E-Mail-Adresse möglich. In diesem Fall werden
                die mit der E-Mail übermittelten personenbezogenen Daten des
                Nutzers gespeichert. Die Daten werden ausschließlich für die
                Verarbeitung der Konversation verwendet. Rechtsgrundlage für die
                Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des
                Nutzers Art. 6 Abs. 1 lit. a DSGVO.
              </p>
            </div>

            <div data-id="element-153">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-154">
                6. Cookies
              </h2>
              <p data-id="element-155">
                Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich
                um Textdateien, die im Internetbrowser bzw. vom Internetbrowser
                auf dem Computersystem des Nutzers gespeichert werden. Ruft ein
                Nutzer eine Website auf, so kann ein Cookie auf dem
                Betriebssystem des Nutzers gespeichert werden. Dieser Cookie
                enthält eine charakteristische Zeichenfolge, die eine eindeutige
                Identifizierung des Browsers beim erneuten Aufrufen der Website
                ermöglicht. Wir setzen Cookies ein, um unsere Website
                nutzerfreundlicher zu gestalten. Rechtsgrundlage für die
                Verarbeitung personenbezogener Daten unter Verwendung von
                Cookies ist Art. 6 Abs. 1 lit. f DSGVO.
              </p>
            </div>

            <div data-id="element-156">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-157">
                7. Rechte der betroffenen Person
              </h2>
              <p data-id="element-158">
                Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie
                Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte
                gegenüber dem Verantwortlichen zu:
              </p>
              <ul className="list-disc list-inside mt-3 space-y-1 text-muted" data-id="element-159">
                <li data-id="element-160">Auskunftsrecht (Art. 15 DSGVO)</li>
                <li data-id="element-161">Recht auf Berichtigung (Art. 16 DSGVO)</li>
                <li data-id="element-162">
                  Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)
                </li>
                <li data-id="element-163">Recht auf Löschung (Art. 17 DSGVO)</li>
                <li data-id="element-164">Recht auf Unterrichtung (Art. 19 DSGVO)</li>
                <li data-id="element-165">Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li data-id="element-166">Widerspruchsrecht (Art. 21 DSGVO)</li>
                <li data-id="element-167">
                  Recht auf Widerruf der datenschutzrechtlichen
                  Einwilligungserklärung (Art. 7 Abs. 3 DSGVO)
                </li>
                <li data-id="element-168">
                  Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77
                  DSGVO)
                </li>
              </ul>
            </div>

            <div data-id="element-169">
              <h2 className="text-lg font-heading font-semibold text-accent mb-3" data-id="element-170">
                8. SSL-Verschlüsselung
              </h2>
              <p data-id="element-171">
                Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der
                Übertragung vertraulicher Inhalte eine SSL-Verschlüsselung. Eine
                verschlüsselte Verbindung erkennen Sie daran, dass die
                Adresszeile des Browsers von „http://" auf „https://" wechselt
                und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </div>

            <div className="border-t border-border pt-8 text-sm text-muted" data-id="element-172">
              <p data-id="element-173">Stand: April 2026</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}